import { useGetList } from 'react-admin';
import { nth } from 'lodash';
import { GROUP_AVATARS } from '@/utils/CONST';
import { GroupAvatar } from '@/utils/types';

interface Output {
    isLoading: boolean;
    groupAvatars: GroupAvatar[] | undefined;
    firstGroupAvatar: GroupAvatar | undefined;
    firstGroupAvatarId: GroupAvatar['id'] | undefined;
    refetch: any;
}

interface Params {
    filters?: any;
    enabled?: boolean;
}

const useGetGroupAvatars = ({ filters = {}, enabled = true }: Params): Output => {
    const { data, isLoading, refetch }: any = useGetList(
        GROUP_AVATARS,
        {
            filter: {
                ...filters,
            },
        },
        {
            enabled,
        },
    );

    const groupAvatars = data as GroupAvatar[] | undefined;
    const firstGroupAvatar = nth(groupAvatars ?? [], 0);

    return {
        groupAvatars,
        firstGroupAvatar,
        firstGroupAvatarId: firstGroupAvatar?.id,
        isLoading,
        refetch,
    };
};

export default useGetGroupAvatars;
